var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChevronS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 15.778c-.256 0-.512-.095-.707-.285l-6-5.833a.95.95 0 0 1 0-1.375 1.02 1.02 0 0 1 1.414 0L12 13.431l5.293-5.146a1.02 1.02 0 0 1 1.414 0 .95.95 0 0 1 0 1.375l-6 5.833c-.195.19-.451.285-.707.285"
})));
export default SvgGemChevronS;